/**
 * Which route gets how much motion.
 *
 * First match wins, and the QUIET rules are listed first on purpose: they are
 * the protective level, so a marketing pattern added later cannot capture a
 * form route by being broader.
 */
import type { MotionLevel } from "./tokens";

type Rule = { test: RegExp; level: MotionLevel };

const RULES: Rule[] = [
  { test: /^\/auth(\/|$)/, level: "quiet" },
  { test: /^\/reset-password(\/|$)/, level: "quiet" },
  { test: /^\/apply(\/|$)/, level: "quiet" },
  { test: /^\/application-submitted(\/|$)/, level: "quiet" },
  { test: /^\/profile(\/|$)/, level: "quiet" },
  { test: /^\/account(\/|$)/, level: "quiet" },

  { test: /^\/$/, level: "loud" },
  { test: /^\/solutions(\/|$)/, level: "loud" },
  { test: /^\/about(\/|$)/, level: "loud" },
  { test: /^\/pricing(\/|$)/, level: "loud" },
  { test: /^\/security(\/|$)/, level: "loud" },

  { test: /^\/contact(\/|$)/, level: "medium" },
  { test: /^\/jobs(\/|$)/, level: "medium" },
  { test: /^\/job(\/|$)/, level: "medium" },
  { test: /^\/forum(\/|$)/, level: "medium" },
  { test: /^\/privacy(\/|$)/, level: "medium" },
  { test: /^\/terms(\/|$)/, level: "medium" },
];

/** Anything unrecognised gets the least motion, never the most, so a route
    added later has to be opted up rather than inheriting scroll-jacking. */
export const DEFAULT_LEVEL: MotionLevel = "quiet";

export function motionLevelFor(pathname: string): MotionLevel {
  for (const rule of RULES) {
    if (rule.test.test(pathname)) return rule.level;
  }
  return DEFAULT_LEVEL;
}
